import { ERROR_MESSAGES } from '@library/constants/errorMessages';
import { ErrorMessage } from '@library/components/messages';
import { Input } from '@library/components/inputs';
import type { InputProps } from '@library/components/inputs';
import { isValidEmail } from '@library/utils';
import { useDebounce } from '@library/hooks/useDebounce';

export interface EmailInputProps extends InputProps {
  id: string;
  value: string;
  onValueChange: (value: string) => void;
}

export function EmailInput({
  id,
  onValueChange,
  value,
  ...rest
}: EmailInputProps) {
  const handleOnChange = (emailInput = '') => {
    onValueChange(emailInput.replace(/\s/g, ''));
  };

  const debouncedValue = useDebounce<string>({
    value,
    delay: 500
  });

  const isEmailValid = isValidEmail(debouncedValue);

  return (
    <>
      <Input
        type="email"
        id={id}
        labelName="EMAIL"
        onValueChange={handleOnChange}
        value={value}
        {...rest}
      />
      <ErrorMessage
        failedValidation={!isEmailValid}
        failureMessages={ERROR_MESSAGES.INVALID_EMAIL}
      />
    </>
  );
}
